import { bool, func, node, string } from 'prop-types';
import Modal from '../../common/Modal';

import './index.css'

// Modal genérico de alta directa: el consumidor provee los campos del gate como children
// y controla canConfirm. Construido sobre el shell common/Modal (no extiende MessageModal).
const CrearCuentaModal = ({ show, title, canConfirm, confirmLabel, onConfirm, onDismiss, size, children }) => {

    const footer = (
        <>
            <button className="btn btn-outline-primary" data-dismiss="modal" onClick={() => onDismiss()}>Cancelar</button>
            <button className="btn btn-primary" data-dismiss="modal" disabled={!canConfirm} onClick={() => onConfirm()}>{confirmLabel}</button>
        </>
    );

    return (
        <Modal
            className="crear-cuenta-modal"
            onEscape={() => onDismiss()}
            show={show}
            size={size}
            title={title}
            body={children}
            footer={footer}
        />
    );
};

CrearCuentaModal.propTypes = {
    show: bool,
    title: string,
    canConfirm: bool,
    confirmLabel: string,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
    size: string,
    children: node
};

CrearCuentaModal.defaultProps = {
    show: true,
    title: 'Creación de cuenta',
    canConfirm: false,
    confirmLabel: 'Continuar',
    size: 'md'
};

export default CrearCuentaModal;
